import { useUpdateUserState } from '@modules/users/hooks';
import { UserRow, UserRowRoleType } from '@modules/users/store/types';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { UserState } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { ActiveUserRoleColumnCellActions } from './ActiveUserRoleColumnCellActions';

interface UserRoleColumnCellActionsProps {
  params: GridRenderCellParams<UserRow, UserRowRoleType, unknown>;
}

export const UserRoleColumnCellActions = ({
  params,
}: UserRoleColumnCellActionsProps) => {
  const { id: userID } = useGetUser();
  const { updateUserState, isLoading: isUserStateUpdateInProgress } =
    useUpdateUserState();

  const { id: rowUserID, role, email } = params.row;

  if (rowUserID === userID) {
    return null;
  }

  if (isUserStateUpdateInProgress) {
    return (
      <Box height="98%" position="absolute" top={0} right={10}>
        <CircularProgress size={34} />
      </Box>
    );
  }

  return (
    <Stack
      height="98%"
      position="absolute"
      direction="row"
      justifyContent="end"
      top={0}
      right={10}
      className="js-row-actions-menu"
      sx={{ opacity: 0 }}
    >
      {role === UserRowRoleType.Suspended ? (
        <Tooltip title="Reactivate User" placement="top">
          <IconButton
            onClick={() => updateUserState(rowUserID, UserState.Active, email)}
          >
            <PersonAddAltRoundedIcon
              fontSize="small"
              sx={{
                color: 'text.secondary',
              }}
            />
          </IconButton>
        </Tooltip>
      ) : (
        <ActiveUserRoleColumnCellActions
          email={email}
          userID={rowUserID}
          userRole={role}
        />
      )}
    </Stack>
  );
};
